import toPlainObject from "lib/utils/toPlainObject";

import prefix from "./prefix";

export const getAttr = (scope) => {
  return (state, attr) => {
    if (scope) {
      try {
        return state[scope][prefix].get(attr);
      } catch (e) {
        throw new Error(
          `state slice not found with` +
            `\nscope: ${scope}` +
            `\nprefix: ${prefix}` +
            `\nattr: ${attr}`,
        );
      }
    } else {
      try {
        return state[prefix].get(attr);
      } catch (e) {
        throw new Error(
          `state not found with` + `\nprefix: ${prefix}` + `\nattr: ${attr}`,
        );
      }
    }
  };
};

export const getTotal = (scope) => (state) => getAttr(scope)(state, "total");

export const getPage = (scope) => (state) => getAttr(scope)(state, "currentPage");

export const getTotalPages = (scope) => (state) => getAttr(scope)(state, "totalPages");

export const hasPagesRemaining = (scope) => (state) =>
  getPage(scope)(state) < getTotalPages(scope)(state);

export const getPaginationInfo = (scope) => (state) => ({
  page: getPage(scope)(state),
  totalPages: getTotalPages(scope)(state),
  hasPagesRemaining: hasPagesRemaining(scope)(state),
});

export const isFirstPage = (scope) => (state) => getPage(scope)(state) <= 1;
export const isLastPage = (scope) => (state) =>
  getPage(scope)(state) >= getTotalPages(scope)(state);

export const getPaginationLoading = (scope) => (state) =>
  getAttr(scope)(state, "loading");
